import React from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import appLogoLight from "../../assets/svg/app_logo_light.svg";
import overlay from "../../assets/svg/bg_overlay.png";

const Wrapper = styled.div`
	${tw`h-screen w-full`}
`;

const CarouselBody = (props) => {
	const { src, text1, text2 } = props;

	return (
		<Wrapper className="carousel-body" tw="h-screen w-full">
			<img src={src} alt="" tw="h-screen w-full" />
			<div tw="absolute inset-0 text-white">
				<div tw="relative h-screen mx-auto">
					<div>
						<img
							src={overlay}
							alt="Wedding Story"
							tw="h-screen w-full absolute"
						/>
					</div>
					<div tw="flex justify-center items-center">
						<img
							src={appLogoLight}
							alt="Wedding Story"
							tw="sm:w-48! md:w-80! h-auto pt-24 my-auto z-10"
						/>
					</div>

					<div tw="flex justify-center items-center">
						<span tw="absolute bottom-36 mx-auto text-center leading-10 font-bold sm:text-2xl! md:text-3xl! z-10">
							{text1} <br /> {text2}
						</span>
					</div>
				</div>
			</div>
		</Wrapper>
	);
};

export default CarouselBody;
